import { Dispatch } from 'react'

export function setValueSmoothly({
  from,
  to,
  setValue,
  duration = 150,
  onEnd,
}: {
  from: number
  to: number
  setValue: Dispatch<number>
  duration?: number
  onEnd?: () => void
}): () => void {
  const start = Date.now()
  const delta = to - from
  let frame: number

  const fn = () => {
    const elapsed = Math.min(1, (Date.now() - start) / duration)

    setValue(from + delta * elapsed)

    if (elapsed < 1) {
      frame = requestAnimationFrame(fn)
    } else if (onEnd) {
      onEnd()
    }
  }

  frame = requestAnimationFrame(fn)

  return () => {
    cancelAnimationFrame(frame)
  }
}
